export const EDIT_MEMBER_MODAL_NAME = 'EDIT_MEMBER_MODAL_NAME';
